import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsDeleteUndelete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForDeleteJob: "/api/v1/portal/jobs/delete-job/",
      apiUrlForUndeleteJob: "/api/v1/portal/jobs/undelete-job/",
      deleteJobReason: null,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }
  deleteJob() {
    return fetch(
      this.state.apiUrlForDeleteJob+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        body: JSON.stringify({deletion_reason: this.state.deleteJobReason}),
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json',
          "Content-Type": 'application/json',
        },
      }
    ).then((responseText) => {
      }
    );
  }
  undeleteJob() {
    return fetch(
      this.state.apiUrlForUndeleteJob+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      }
    );
  }
  deleteJobReasonData(e){
    this.setState({
        deleteJobReason: e.target.value
      });
  }

  render() {
    return(
      <span> {
     (this.state.data.status !== 'deleted') ?
        <div className="delete_reason_div">
          <button
           className="btn btn-lg btn-secondary"
           onClick={() => {
             this.deleteJob(this.state.data.id)
           }}>
           <i className="fa fa-trash"></i>&nbsp;
           Delete Job
          </button>          
          <textarea name="deletion_reason" value={this.state.deleteJobReason || ''} onChange={e => this.deleteJobReasonData(e)} placeholder="Enter Reason"></textarea>
        </div>
       :
        <div className="delete_reason_div">
          <button
             className="btn btn-lg btn-secondary"
             onClick={() => {
               this.undeleteJob(this.state.data.id)
             }}>
             <i className="fa fa-undo"></i>&nbsp;
             Undelete Job
          </button>
          <div className="deleted_job_details">
                <p>
                  <strong>deleted By : </strong>
                  {(this.state.data.deleted_by && this.state.data.deleted_by.full_name)?this.state.data.deleted_by.full_name:null}
                </p>
                <p>
                  <strong>deleted Time : </strong>
                  {this.state.data.deleted_at}
                </p>
                <p>
                  <strong>Deletion Reason : </strong>
                  {this.state.data.deletion_reason}
                </p>
              </div>
        </div>
      }
    </span>
    )
  }
}